// processing.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlockNavigationService {

  private processingSubject = new BehaviorSubject<boolean>(false);

  processing$: Observable<boolean> = this.processingSubject.asObservable();

  blockNavigation(status: boolean): void {
    console.log(`blockNavigation: ${status}`)

    this.processingSubject.next(status);
  }

  isBlocked(): boolean {
    return this.processingSubject.value;
  }
}